/*eslint-disable*/
//the linter does not like having the google api here
import { SET_STOPS_STATE, SET_STOPS, StopActionTypes } from "./StopActions";
import StopState from "./StopState";
import stopStateStyles from "../../stopStateStyles";
import StopType from "Containers/Stops/StopType";

const initialState = [];

const StopReducer = (state = initialState, action: StopActionTypes) => {
  switch (action.type) {
    case SET_STOPS:
      return action.payload;
    case SET_STOPS_STATE:
      return state.map((stop: any) => {
        if (action.payload.stopIds.includes(stop.id) && stop.polygon) {
          const isSelected = stop.state === StopState.Selected;
          const stateStyle = isSelected
            ? StopState.Visited
            : action.payload.state;

            stop.polygon.forEach((polygon) => {
              polygon.setOptions({
                ...polygon,
                strokeColor: stopStateStyles[stateStyle][polygon.type].strokeColor,
                fillColor: stopStateStyles[stateStyle][polygon.type].fillColor,
                fillOpacity: 1,
              })
            })
          return {
            ...stop,
            state: stateStyle,
            polygon: stop.polygon,
          };
        } else if (stop.polygon) {
          // If the stop is not currently selected, set to VISITED state if previously selected
          if (stop.state === StopState.Selected) {
            stop.polygon.forEach((polygon) => {
              polygon.setOptions({
                ...polygon,
                strokeColor: stopStateStyles[StopState.Visited][polygon.type].strokeColor,
                fillColor: stopStateStyles[StopState.Visited][polygon.type].fillColor,
                fillOpacity: 1,
              })
            })
            return {
              ...stop,
              state: StopState.Visited,
              polygon: stop.polygon,
            };
          }
        }
        // If a stop is in DEFAULT or VISITED state, leave it as it is
        return stop;
      });
    default:
      return state;
  }
};

export default StopReducer;
